import axios from 'axios'
import swal from 'sweetalert2'
import store from '../store'

axios.defaults.withCredentials = true

axios.interceptors.response.use(
  response => response,
  error => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }

    if (!error.response) {
      return Promise.reject(error)
    }

    /**
     * 401 response indicates the request requires login.
     *
     * I've intentionally placed this code above the logic that allows skipping this interceptor, because
     * if the request requires the user to login, there's no point in handling any other errors.
     */
    if (
      error.response.status === 401 &&
      (!error.response.data.hasOwnProperty('@type') ||
        error.response.data['@type'] !== 'bad_credentials')
    ) {
      store.dispatch('openLoginDialog')
      return Promise.reject(error)
    }

    /**
     * Allows Axios calls to skip the default error handling logic.
     */
    if (error.config.hasOwnProperty('handleErrors') && !error.config.handleErrors) {
      return Promise.reject(error)
    }

    const showError = message => {
      swal('Error', message, 'error').then()
    }

    const processConventionalResponse = defaultMessage => {
      // API responses contain this key when request was for application/ld+json
      if ('hydra:description' in error.response.data) {
        showError(error.response.data['hydra:description'])
      }
      // API responses contain this key when request was for application/json
      else if ('detail' in error.response.data) {
        showError(error.response.data.detail)
      }
      // Catch-all
      else {
        showError(defaultMessage)
      }
    }

    /**
     * API returns 400 on validation errors.
     */
    if (
      error.response.status === 400 &&
      (!error.config.hasOwnProperty('handleValidationErrors') ||
        error.config.handleValidationErrors)
    ) {
      processConventionalResponse('400 Bad Request')
      return Promise.reject(error)
    }

    if (error.response.status === 403) {
      processConventionalResponse('Access denied.')
      return Promise.reject(error)
    }

    if (error.response.status === 500) {
      processConventionalResponse('Internal server error.')
      return Promise.reject(error)
    }

    /**
     * Allows additional error handlers to be triggered.
     */
    return Promise.reject(error)
  }
)
